module.exports = __webpack_public_path__ + "static/img/btn-submit.9ae5d297.png";